export class SendCommitterCommandResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "command",
            "baseName": "command",
            "type": "CommitterCommand",
            "format": ""
        },
        {
            "name": "sealCompaction",
            "baseName": "sealCompaction",
            "type": "CommitterSealCompactionStats",
            "format": ""
        },
        {
            "name": "maintenance",
            "baseName": "maintenance",
            "type": "CommitterMaintenanceStats",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SendCommitterCommandResponse.attributeTypeMap;
    }
    constructor() {
    }
}
